import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { BarI18nPipe } from '../../i18n/bar-i18n.pipe';

@Component({
    templateUrl: './baas-edit-loader.html',
    selector: 'baas-edit-loader',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatProgressBarModule, BarI18nPipe]
})
export class BaasEditLoader {
    readonly hidden = input<boolean>(false);
}
